import { AuthPersonApiFactory } from '@mynt/backoffice-api-spec/auth-person'
import Axios from 'api/axios'
import config from 'config'
import type { AuthPersonInfo } from '../types'
import { mapPersonAuthResponseToAuthPersonInfo } from './mappers'

const authPersonApi = AuthPersonApiFactory(undefined, config.boBaseUrl, Axios)

export const getAuthPersonInfo = async (authPersonId: string): Promise<AuthPersonInfo> => {
  return await authPersonApi.getPersonAuth(authPersonId).then(({ data }) => mapPersonAuthResponseToAuthPersonInfo(data))
}

export const deleteAuthPerson = async (authPersonId: string): Promise<void> => {
  await authPersonApi.deletePersonAuth(authPersonId)
}
